module.exports = __webpack_public_path__ + "img/empty_default.43038bb9.jpg";